var id = Math.ceil(Math.random() * 10);

module.exports = function() {
    return ++id;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-json-inspector/lib/uid.js
 ** module id = 324
 ** module chunks = 0
 **/